import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PartnerFeedbackSummary from './PartnerFeedbackSummary';

const PartnerFeedbackSummaryRoot = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path={['/lessons/:id/role_plays/:rolePlayId']}
          exact
          component={PartnerFeedbackSummary}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default PartnerFeedbackSummaryRoot;
